// src/pages/currentAccountReport/CurrentAccountReportPage.jsx
import React from 'react';
import CurrentAccountReportFilters from './components/CurrentAccountReportFilters';
import CurrentAccountReportTable from './components/CurrentAccountReportTable';
import useCurrentAccountReportData from './hooks/useCurrentAccountReportData';
import { useLanguage } from '../../../contexts/LanguageContext';
import { useLazyExportCurrentAccountReportToExcelQuery } from '../../../api/endpoints/currentAccountReport';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';

const CurrentAccountReportPage = () => {
    const { th } = useLanguage();
    const {
        rows,
        loading,
        totalCount,
        pagination,
        filterFields,
        handleApplyFilters,
        handleResetFilters,
        onPageChange,
        exportParams,
        customerDropdown, // ★ Yeni
    } = useCurrentAccountReportData();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('currentAccountReport.title') || 'Cari Rapor'}</h1>
                <GenericFileExportButton
                    useExportQuery={useLazyExportCurrentAccountReportToExcelQuery}
                    exportParams={exportParams}
                    buttonLabel={th("common.export") || "Excel"}
                    buttonClassName="p-button-success"
                    icon="pi pi-file-excel"
                    fileNameExtractor={(result) => result?.fileName || "cari_rapor.xlsx"}
                    dataExtractor={(result) => result?.fileBase64}
                    contentTypeExtractor={(result) => result?.contentType}
                />
            </div>

            <div className="mb-2">
                <CurrentAccountReportFilters
                    filterFields={filterFields}
                    handleApplyFilters={handleApplyFilters}
                    handleResetFilters={handleResetFilters}
                    customerDropdown={customerDropdown} // ★ Yeni prop
                />
            </div>

            <CurrentAccountReportTable
                rows={rows}
                loading={loading}
                totalCount={totalCount}
                pagination={pagination}
                onPageChange={onPageChange}
            />
        </div>
    );
};

export default CurrentAccountReportPage;